export default {
  generalOther: {
    issues: [
      {
        id: 'I-PE-11400',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  headNormocephalkANDtemporalWasting: {
    issues: [
      {
        id: 'I-PE-1000',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Temporal Wasting'
  },
  headAtraumaticANDstructuralAnomaly: {
    issues: [
      {
        id: 'I-PE-11500',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Structural Anomaly'
  },
  headOther: {
    issues: [
      {
        id: 'I-PE-1200',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  eyesIcterus: {
    issues: [
      {
        id: 'I-PE-1400',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Icterus'
  },
  eyesPerrlbANDanisocoria: {
    issues: [
      {
        id: 'I-PE-1600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Anisocoria'
  },
  eyesEomiANDnystagmus: {
    issues: [
      {
        id: 'I-PE-1800',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Nystagmus'
  },
  eyesOther: {
    issues: [
      {
        id: 'I-PE-2000',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  neckLAD: {
    issues: [
      {
        id: 'I-PE-2200',
        domain: 'DPE'
      }
    ],
    triggerValue: 'LAD'
  },
  neckROM: {
    issues: [
      {
        id: 'I-PE-2400',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Rigidity'
  },
  neckOther: {
    issues: [
      {
        id: 'I-PE-2600',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  respiratoryWheezing: {
    issues: [
      {
        id: 'I-PE-2800',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Wheezing'
  },
  respiratoryCrackles: {
    issues: [
      {
        id: 'I-PE-3000',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Crackles'
  },
  respiratoryMovement: {
    issues: [
      {
        id: 'I-PE-3200',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Decreased Movement'
  },
  respiratoryOther: {
    issues: [
      {
        id: 'I-PE-3400',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  cardiovascularRhythm: {
    issues: [
      {
        id: 'I-PE-3600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Irregular Rhythm'
  },
  cardiovascularRate: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-3800',
          domain: 'DPE',
          triggerValue: 'Tachycardia'
        },
        {
          id: 'I-PE-4000',
          domain: 'DPE',
          triggerValue: 'Bradycardia'
        }
      ]
    }
  },
  cardiovascularNormalSoundANDabnormalSound: {
    issues: [
      {
        id: 'I-PE-11600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Abnormal Heart Valve Sounds'
  },
  cardiovascularMurmur: {
    issues: [
      {
        id: 'I-PE-4200',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Murmur'
  },
  cardiovascularOther: {
    issues: [
      {
        id: 'I-PE-4400',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  abdomenSoftOrFirm: {
    issues: [
      {
        id: 'I-PE-4600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Firm'
  },
  abdomenTender: {
    issues: [
      {
        id: 'I-PE-4800',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Tender'
  },
  abdomenDistended: {
    issues: [
      {
        id: 'I-PE-5000',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Distended'
  },
  abdomenNoOrganomegalyANDorganomegaly: {
    issues: [
      {
        id: 'I-PE-5200',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Organomegaly'
  },
  abdomenActiveBS: {
    issues: [
      {
        id: 'I-PE-5400',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Hypoactive Sounds'
  },
  abdomenSuprapubicTenderness: {
    issues: [
      {
        id: 'I-PE-5600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Suprapubic Tenderness'
  },
  abdomenOther: {
    issues: [
      {
        id: 'I-PE-5800',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  backTender: {
    issues: [
      {
        id: 'I-PE-6000',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Tender'
  },
  backMasses: {
    issues: [
      {
        id: 'I-PE-6200',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Masses'
  },
  backCVA: {
    issues: [
      {
        id: 'I-PE-6400',
        domain: 'DPE'
      }
    ],
    triggerValue: 'CVA Tenderness'
  },
  backROM: {
    issues: [
      {
        id: 'I-PE-6600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Limited ROM'
  },
  backAlignment: {
    issues: [
      {
        id: 'I-PE-6800',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Abnormal Alignment'
  },
  backOther: {
    issues: [
      {
        id: 'I-PE-7000',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  genitourinaryOther: {
    issues: [
      {
        id: 'I-PE-7200',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  extremitiesClubbing: {
    issues: [
      {
        id: 'I-PE-7400',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Clubbing'
  },
  extremitiesTender: {
    issues: [
      {
        id: 'I-PE-7600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Tender'
  },
  extremitiesROM: {
    issues: [
      {
        id: 'I-PE-7800',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Limited ROM'
  },
  extremitiesEdema: {
    issues: [
      {
        id: 'I-PE-8000',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Edema'
  },
  extremitiesCyanosis: {
    issues: [
      {
        id: 'I-PE-8200',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Cyanosis'
  },
  extremitiesOther: {
    issues: [
      {
        id: 'I-PE-8400',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  neurologicalMotor: {
    issues: [
      {
        id: 'I-PE-8600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Weakness'
  },
  neurologicalSensory: {
    issues: [
      {
        id: 'I-PE-8800',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Sensory Deficit'
  },
  neurologicalGait: {
    issues: [
      {
        id: 'I-PE-9000',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Limited Gait'
  },
  neurologicalCranialNerves: {
    issues: [
      {
        id: 'I-PE-9200',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Cranial Nerve Deficit'
  },
  neurologicalOther: {
    issues: [
      {
        id: 'I-PE-9400',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  integumentaryRashes: {
    issues: [
      {
        id: 'I-PE-9600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Rashes'
  },
  integumentaryLesions: {
    issues: [
      {
        id: 'I-PE-9800',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Lesions'
  },
  integumentaryJaundice: {
    issues: [
      {
        id: 'I-PE-10100',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Jaundice'
  },
  integumentaryOther: {
    issues: [
      {
        id: 'I-PE-10200',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  },
  mentalhealthAlertness: {
    issues: [
      {
        id: 'I-PE-10400',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Lethargic'
  },
  mentalhealthOrientation: {
    issues: [
      {
        id: 'I-PE-10600',
        domain: 'DPE'
      }
    ],
    triggerValue: 'Confused'
  },
  mentalhealthAffect: {
    differentTriggerValues: {
      issues: [
        {
          id: 'I-PE-10800',
          domain: 'DPE',
          triggerValue: 'Withdrawn'
        },
        {
          id: 'I-PE-11000',
          domain: 'DPE',
          triggerValue: 'Manic'
        }
      ]
    }
  },
  mentalhealthOther: {
    issues: [
      {
        id: 'I-PE-11200',
        domain: 'DPE'
      }
    ],
    triggerValue: true
  }
}
